
import types from '../store/mutation-types'
import qs from 'qs'
import ChinaAddressV2Data from 'vux/src/datas/china_address_v2.json'

import getAgeFromBirthday from '../utils/getAgeFromBirthday'

export default {
name: 'm-measure',
data () {
return {
ChinaAddressV2Data: ChinaAddressV2Data
}
},
created () {
/**
* 打开详情页，即计算保费
* 这是为了保费测算后，在订单页修改了数据，再返回打开测算，保费不更新的问题
*/
if (this.birthday === '') return
this.getFee(true)
},
mounted () {
window.onresize = () => {
return (() => {
this.$refs.measureBody.style.maxHeight = (window.innerHeight - 120) + 'px'
})()
}

},
computed: {
measureForm () {
return this.$store.state.config.measure.form
},
insuredRelations () {
if (this.$store.state.config.measure && this.$store.state.config.measure.status) {
const insuredRelations = []
this.$store.state.config.form.insuredRelations.list.forEach(ele => {
insuredRelations.push({
name: ele.name,
value: ele.value
})
})
return insuredRelations
}
},
insuredRelation: {
get () {
return this.$store.state.order.insuredRelation
},
set (value) {
this.$store.commit(types.UPDATE_INSUREDRELATION, value)
}
},
defaultSelectedValue () {

const insuredRelationsList = this.$store.state.config.form.insuredRelations.list
for (let i = 0, l = insuredRelationsList.length; i < l; i++) {
if (insuredRelationsList[i].value === this.insuredRelation && insuredRelationsList[i].defaultBirth) {
return insuredRelationsList[i].defaultBirth
}
}
return this.$store.state.config.form.birthday.default
},
birthday: {
get () {
return this.$store.state.order.birthday
},
set (value) {
this.$store.commit(types.UPDATE_BIRTHDAY, value)
}
},
birthdayConstraints () {
return this.$store.getters.birthdayConstraints
},
sexs () {
if (this.$store.state.config.measure && this.$store.state.config.measure.status) {
const sexs = []
this.$store.state.config.form.sexs.list.forEach(ele => {
sexs.push({
name: ele.name,
value: ele.value
})
})
return sexs
}
},
sex: {
get () {
return this.$store.state.order.sex
},
set (value) {
this.$store.commit(types.UPDATE_SEX, value)
}
},
coverages () {
if (this.$store.state.config.measure && this.$store.state.config.measure.status) {
const coverages = []
const age = getAgeFromBirthday(this.birthday).y
this.$store.state.config.form.coverages.list.forEach(ele => {
const tempCoverage = {
name: ele.name + '万',
value: ele.value
}

if (this.birthday && ele.constraints) {
if (age < ele.constraints.age.begin || age > ele.constraints.age.end) {
tempCoverage.accessable = false
}
}
coverages.push(tempCoverage)
})

for (let i = 0, l = coverages.length; i < l; i++) {

if (coverages[i].accessable === false) {
if (coverages[i].value === this.coverage) {
for (let i = 0, l = coverages.length; i < l; i++) {
if (coverages[i].accessable !== false) {
this.$store.commit(types.UPDATE_COVERAGE, coverages[i].value)
break
}
}
}
}
}
return coverages
}
},
coverage: {
get () {
return this.$store.state.order.coverage
},
set (value) {
this.$store.commit(types.UPDATE_COVERAGE, value)
}
},
paymentPeriods () {
if (this.$store.state.config.measure && this.$store.state.config.measure.status) {
const paymentPeriods = []
const age = getAgeFromBirthday(this.birthday).y
this.$store.state.config.form.paymentPeriods.list.forEach(ele => {
const tempPaymentPeriod = {
name: ele.value + '年',
value: ele.value
}

if (ele.constraints) {
ele.constraints.forEach(c => {
const test = {}
if (c.age && age && age >= c.age.begin && age <= c.age.end) {
test.age = true
} else {
test.age = false
}
if (c.insurancePeriods) {
test.insurancePeriods = false
c.insurancePeriods.forEach(ele => {
if (ele.value === this.insurancePeriod) {
test.insurancePeriods = true
}
})
}
let allTest = true
for (let key in test) {
if (!test[key]) allTest = false
}
if (allTest) {
tempPaymentPeriod.accessable = false

if (this.paymentPeriod === ele.value) {

for (let i = 0, l = this.$store.state.config.form.paymentPeriods.list.length; i < l; i++) {
if (this.$store.state.config.form.paymentPeriods.list[i].default) {
this.$store.commit(types.UPDATE_PAYMENTPERIOD, this.$store.state.config.form.paymentPeriods.list[i].value)
break
}
}
}
}
})
}
paymentPeriods.push(tempPaymentPeriod)
})

/**
* 特殊说明
* 百年人寿轻症豁免版 51-55周岁男性，30年交期不可选
* 150476691002746473
* 150537492578996275
*/
if (age !== null &&
age >= 51 &&
age <= 55 &&
['150476691002746473', '150537492578996275'].indexOf(this.$store.state.app.productCode) !== -1 &&
this.sex === 1) {
paymentPeriods.forEach((ele) => {
if (ele.value === 30) {
ele.accessable = false
}
})
}


for (let i = 0, l = paymentPeriods.length; i < l; i++) {

if (paymentPeriods[i].accessable === false) {
if (paymentPeriods[i].value === this.paymentPeriod) {
for (let i = 0, l = paymentPeriods.length; i < l; i++) {
if (paymentPeriods[i].accessable !== false) {
this.$store.commit(types.UPDATE_PAYMENTPERIOD, paymentPeriods[i].value)
break
}
}
}
}
}
return paymentPeriods
}
},
paymentPeriod: {
get () {
return this.$store.state.order.paymentPeriod
},
set (value) {
this.$store.commit(types.UPDATE_PAYMENTPERIOD, value)
}
},
insurancePeriods () {
if (this.$store.state.config.measure && this.$store.state.config.measure.status) {
const insurancePeriods = []
const age = getAgeFromBirthday(this.birthday).y
this.$store.state.config.form.insurancePeriods.list.forEach(ele => {
const tempInsurancePeriods = {
value: ele.value.value
}
if (ele.value.type === 'age') {
tempInsurancePeriods.name = '至' + ele.value.value + '周岁'
} else if (ele.value.type === 'years') {
tempInsurancePeriods.name = ele.value.value + '年'
} else if (ele.value.type === 'lifelong') {
tempInsurancePeriods.name = '终身'
}
if (ele.constraints) {
let tests = []
ele.constraints.forEach(c => {
const test = {}
if (c.age) {
if (age) {
if (age <= c.age.end && age >= c.age.begin) {
test.age = true
} else {
test.age = false
}
} else {
test.age = true
}
}
if (c.paymentPeriods) {
test.insurancePeriods = false
if (c.paymentPeriods.indexOf(this.paymentPeriod) !== -1) {
test.insurancePeriods = true
}
}
let allTest = true
for (let key in test) {
if (!test[key]) allTest = false
}
tests.push(allTest)
})
if (tests.indexOf(true) === -1) {
tempInsurancePeriods.accessable = false
}
}
insurancePeriods.push(tempInsurancePeriods)
})

for (let i = 0, l = insurancePeriods.length; i < l; i++) {

if (insurancePeriods[i].accessable === false) {
if (insurancePeriods[i].value === this.insurancePeriod) {
for (let i = 0, l = insurancePeriods.length; i < l; i++) {
if (insurancePeriods[i].accessable !== false) {
this.$store.commit(types.UPDATE_INSURANCEPERIOD, insurancePeriods[i].value)
break
}
}
}
}
}
return insurancePeriods
}
},
insurancePeriod: {
get () {
return this.$store.state.order.insurancePeriod
},
set (value) {
this.$store.commit(types.UPDATE_INSURANCEPERIOD, value)
}
},
paymentWays () {
const paymentWays = []
this.$store.state.config.form.paymentWays.list.forEach(ele => {
paymentWays.push({
name: ele.name,
value: ele.value
})
})
return paymentWays
},
paymentWay: {
get () {
return this.$store.state.order.paymentWay
},
set (value) {
this.$store.commit(types.UPDATE_PAYMENTWAY, value)
}
},
paymentModes () {
const paymentModes = []
this.$store.state.config.form.paymentModes.list.forEach(ele => {
paymentModes.push({
name: ele.name,
value: ele.value
})
})
return paymentModes
},
paymentMode: {
get () {
return this.$store.state.order.paymentMode
},
set (value) {
this.$store.commit(types.UPDATE_ORDER_PAYMENTMODE, value)
}
},
copiesMin () {
const copiesMinLength = this.$store.state.config.form.copies.min.length
for (let i = 0; i < copiesMinLength; i++) {
if (this.$store.state.config.form.copies.min[i].paymentMode === this.paymentMode) {
return this.$store.state.config.form.copies.min[i].value
}
}
},
copiesMax () {
const copiesMaxLength = this.$store.state.config.form.copies.max.length
for (let i = 0; i < copiesMaxLength; i++) {
if (this.$store.state.config.form.copies.max[i].paymentMode === this.paymentMode) {
return this.$store.state.config.form.copies.max[i].value
}
}
},
mild: {
get () {
return this.$store.state.order.mild
},
set (value) {
this.$store.commit(types.UPDATE_MILD, value)
}
},
mildCoverage () {
return (this.coverage * this.$store.state.config.form.mildCoverage.rate) + '万'
},
occupationType () {
return this.$store.state.config.form.occupation.type
}
},
methods: {
changeRnsuredRelation () {

this.$store.commit(types.UPDATE_BIRTHDAY, '')

for (let i = 0, l = this.$store.state.config.form.sexs.list.length; i < l; i++) {
if (this.$store.state.config.form.sexs.list[i].default) {
this.$store.commit(types.UPDATE_SEX, this.$store.state.config.form.sexs.list[i].value)
break
}
}

for (let i = 0, l = this.$store.state.config.form.coverages.list.length; i < l; i++) {
if (this.$store.state.config.form.coverages.list[i].default) {
this.$store.commit(types.UPDATE_COVERAGE, this.$store.state.config.form.coverages.list[i].value)
break
}
}

for (let i = 0, l = this.$store.state.config.form.paymentPeriods.list.length; i < l; i++) {
if (this.$store.state.config.form.paymentPeriods.list[i].default) {
this.$store.commit(types.UPDATE_PAYMENTPERIOD, this.$store.state.config.form.paymentPeriods.list[i].value)
break
}
}

for (let i = 0, l = this.$store.state.config.form.insurancePeriods.list.length; i < l; i++) {
if (this.$store.state.config.form.insurancePeriods.list[i].default) {
this.$store.commit(types.UPDATE_INSURANCEPERIOD, this.$store.state.config.form.insurancePeriods.list[i].value.value)
break
}
}

for (let i = 0, l = this.$store.state.config.form.paymentWays.list.length; i < l; i++) {
if (this.$store.state.config.form.paymentWays.list[i].default) {
this.$store.commit(types.UPDATE_PAYMENTWAY, this.$store.state.config.form.paymentWays.list[i].value)
break
}
}

const copiesValueLength = this.$store.state.config.form.copies.value.length
for (let i = 0; i < copiesValueLength; i++) {
if (this.$store.state.config.form.copies.value[i].paymentMode === this.paymentMode) {
this.$store.commit(types.UPDATE_COVERAGE, this.$store.state.config.form.copies.value[i].value)
}
}
},
changePaymentMode () {
const copiesValueLength = this.$store.state.config.form.copies.value.length
for (let i = 0; i < copiesValueLength; i++) {
if (this.$store.state.config.form.copies.value[i].paymentMode === this.paymentMode) {
this.$store.commit(types.UPDATE_COVERAGE, this.$store.state.config.form.copies.value[i].value)
}
}
this.getFee()
},
getFee (hideTip) {
setTimeout(() => {
if (this.birthday === '') {
if (!hideTip) {
this.$vux.toast.show({
type: 'text',
text: '客官，不选择年龄无法测算保费',
position: 'top',
width: '20em'
})
}
this.$store.commit(types.UPDATE_MEASURESUCCESS, false)
return
}

const data = {
productCode: this.$store.state.app.productCode,
sex: this.$store.state.order.sex,
age: getAgeFromBirthday(this.$store.state.order.birthday).y,
payType: this.$store.state.order.paymentPeriod,
durationPeriodValue: this.$store.state.order.insurancePeriod,
additionalRiskCodes: this.$store.state.order.mild ? this.$store.state.config.form.mild.default : '',
payMode: this.$store.state.order.paymentMode,
innerCode: this.$store.state.app.innerCode,
utm_source: this.$route.query.utm_source || '',
calculationCode: this.$route.query.calculationCode || '',
coverageMultiples: this.$store.state.order.coverage
}

this.$store.state.config.form.insurancePeriods.list.forEach(ele => {
if (this.$store.state.order.insurancePeriod === ele.value.value) {
data.durationPeriodType = ele.value.typeCode
}
})
this.$http.get('/api/illness/getFee?' + qs.stringify(data)).then(response => {
if (response.data !== false) {
this.$store.commit(types.UPDATE_MEASURESUCCESS, true)
if (response.data.coverage) {
this.$store.commit(types.UPDATE_BASEPREMIUM, response.data.money)
this.$store.commit(types.UPDATE_BASEBACKMONEY, response.data.coverage)
} else {
this.$store.commit(types.UPDATE_BASEPREMIUM, response.data)
}
}
})
}, 0)
}
}
}



// WEBPACK FOOTER //
// ./src/components/Measure.vue